import io from 'socket.io-client';
import defaultStub from './stub.client';

let socket;
const namespace = 'tp-pc';
// const socketArr = __DEV__
//   ? 'http://localhost:30122'
//   : 'https://tp.icourse163.org';
const socketArr = __DEV__
  ? 'http://l.icourse163.org:8002'
  : 'https://tp.icourse163.org';

// socekt连接
const socketLaunch = (token, observer) => {
  socket = io.connect(`${socketArr}/${namespace}`, {
    query: {
      token,
    },
  });

  defaultStub.forEach(({ key, listener }) => {
    socket.on(key, data => {
      listener({ namespace, socket, data });
    });
  });

  // TODO: 连接上返回该socket
  socket.on('connect', () => {
    observer.next(socket);
  });
};

export default socketLaunch;
